import type { LazyLoad, StatesList } from '@tdwb/webbroker/core';
import type { OrderEntryModule } from './order-entry/order-entry.module';

export class TradingRoutes {
  static states: StatesList = [
    {
      name: 'modal.trading.**', // TODO rename to trading-create to convey better meaning
      url: '/trading',
      loadChildren: (): LazyLoad<OrderEntryModule> => import('./order-entry/order-entry.module')
        .then((m: typeof import('./order-entry/order-entry.module')): typeof OrderEntryModule => m.OrderEntryModule),
      redirectTo: 'modal.trading.order'
    }
  ];
}
